import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { loginOwner, logoutOwner } from '../actions/ownerActions.js'
import FormContainer from '../components/FormContainer.js'
import {
  OWNER_DETAILS_RESET,
  OWNER_LOGIN_RESET
} from '../constants/ownerConstants.js'

// LoginScreen component handles user login functionality, including form submission, authentication, and redirection based on user roles and account status.
const OwnerLoginScreen = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const inputRef = useRef()

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { loading, error, ownerInfo } = ownerLogin

  useEffect(() => {
    if (!ownerInfo) {
      return
    }

    if (ownerInfo.isDisabled === true) {
      navigate('/')
      alert('Your account has been disabled. Please contact the administrator.')
      dispatch({ type: OWNER_DETAILS_RESET })
      dispatch({ type: OWNER_LOGIN_RESET })
      dispatch(logoutOwner())
      return
    }

    navigate('/dashboard')
  }, [ownerInfo, dispatch, navigate])

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(loginOwner(email, password))
  }

  return (
    <FormContainer>
      <br />
      <h4>Owner Login</h4>
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group className='mb-3 ' controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            autoFocus
            autoComplete='email'
            ref={inputRef}
            type='email'
            placeholder='Enter email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-3 ' controlId='password'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Enter Password (minimum 6 characters)'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Row className='py-3 justify-content-center'>
          <Col>
            <Button type='submit' variant='outline-primary' className='my-3'>
              Owner Sign In
            </Button>
            <Link
              to={'/owner/register'}
              className='btn btn-outline-secondary my-3'
            >
              Register Here
            </Link>
          </Col>
        </Row>
      </Form>
    </FormContainer>
  )
}

export default OwnerLoginScreen
